import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {PakTenantService} from '../services/pak/pak-tenant.service';
import {NavigationService} from '../services/navigation/navigation.service';

@Component({
  selector: 'shared-selfservice-pak-extensions',
  template: '',
})
export class PakExtensionsComponent implements OnInit, OnDestroy {

  private parentOrigin!: string;
  private keepMeAliveSentDate!: Date;
  private subscriptions: Subscription = new Subscription();
  private actualWindowHeight!: number;
  private readonly SELFSERVICE_CONTENT_ELEMENT_ID = 'app-selfservice-root';

  constructor(private pakTenantService: PakTenantService, private navigationService: NavigationService) { }

  ngOnInit(): void {
    this.pakTenantService.loadIframeResizer();
    this.pakTenantService.addPakDiv();
    this.parentOrigin = window.location.ancestorOrigins[0];
    this.sendKeepMeAliveToWindowParent();
    this.subscriptions.add(this.navigationService.getRouterEvent
      .asObservable()
      .subscribe(() => {
        this.sendPageChangeToWindowParent();
        if (this.isKeepMeAliveRequiredToBeSent()) {
          this.sendKeepMeAliveToWindowParent();
        }
      }));
    this.subscriptions.add(this.pakTenantService.getViewChangedEvent
      .asObservable()
      .subscribe(() => {
        this.sendWindowHeightToWindowParent();
      }));
  }

  isKeepMeAliveRequiredToBeSent(): boolean {
    return this.keepMeAliveSentDate && new Date().getTime() - this.keepMeAliveSentDate.getTime() > 45000;
  }

  sendKeepMeAliveToWindowParent(): void {
    window.parent.postMessage('keepMeAlive', this.parentOrigin);
    this.keepMeAliveSentDate = new Date();
  }

  sendPageChangeToWindowParent(): void {
    window.parent.postMessage('pageChange', this.parentOrigin);
  }

  sendWindowHeightToWindowParent(): void {
    const selfserviceContentElement = document.getElementById(this.SELFSERVICE_CONTENT_ELEMENT_ID);
    if (!!selfserviceContentElement && selfserviceContentElement.scrollHeight !== this.actualWindowHeight) {
      this.actualWindowHeight = selfserviceContentElement.scrollHeight;
      window.parent.postMessage(selfserviceContentElement.scrollHeight.toString(), this.parentOrigin);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
